import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode,   SectionTitle,  Note, Image,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider} from '../../../../components/course/CourseComponents';
import screen1 from '../screen1.jpg';

const IntroductionContent = () => {
  return (
    <>
      <InfoBox title="Introduction" color="blue">
        <p className="mb-0">
        Dans ce quatrième jeu, nous allons apprendre à créer un jeu de type Snake. Cela nous permettra de voir les déplacements avec les touches du clavier, <br/>
        et de revoir les notions de listes et de boucles.
        </p>
      </InfoBox>    

      <SectionTitle>🧠 Objectif du jeu</SectionTitle>
      
      <div className="flex flex-col md:flex-row gap-6 items-start mb-6">
        <div className="flex-1">
          <p className="mb-4">
            Le but du jeu <strong>Snake</strong> est de contrôler un serpent qui se déplace continuellement,
            en ramassant des pommes pour grandir sans jamais se mordre la queue.<br />
            Le joueur marque un point à chaque pomme mangée. Le jeu se termine si le serpent sort de l'écran
            ou se mord lui-même.
          </p>
          
          <p>Voici les notions que nous allons aborder :</p>
          <ul className="list-disc list-inside mb-4">
            <li>Affichage fluide du serpent grâce à une liste de points espacés régulièrement.</li>
            <li>Chargement et affichage d'images pour le fond, la tête, le corps et les pommes.</li>
            <li>Gestion du déplacement en temps réel avec des touches directionnelles.</li>
            <li>Détection des collisions avec les bords ou le corps du serpent.</li>
            <li>Lecture de sons pour les effets de morsure et de fin de partie.</li>
          </ul>
        </div>
        <div className="flex justify-center items-center">
          <Image 
            src={screen1} 
            alt="Aperçu du jeu Snake" 
            width="350px"
            height="350px"
            borderRadius="xl"
            shadow={true}
            border={false}
            className="object-contain"
          />
        </div>
      </div>

      <Note type="tip" title="Technologie utilisée :">
        Nous utiliserons <strong>JavaScript</strong> et la bibliothèque <strong>p5.js</strong>, 
        qui fournit toutes les fonctions nécessaires à la création de jeux vidéo :
        interface simple pour gérer le rendu graphique, gérer les événements utilisateur 
        et l'interaction en temps réel.
      </Note>

      <p>🎯 <strong>Prêt à coder ? C'est parti !</strong></p>
     
    </>
  );
};

export default IntroductionContent; 